import { render } from "./PromoteRepeat.vue?vue&type=template&id=3dae2118&scoped=true"
import script from "./PromoteRepeat.vue?vue&type=script&lang=js"
export * from "./PromoteRepeat.vue?vue&type=script&lang=js"

import "./PromoteRepeat.vue?vue&type=style&index=0&id=3dae2118&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3dae2118"]])

export default __exports__